import axios from "axios";
import {Route} from "vue-router/types/router";
import {UserInfoUtils} from "@/model/user-info/functions/user-info-utils";
import {AxiosUtils} from "@/axios-utils";
import {GtmRouterNext} from "@/router/gtm-router-next";

export class NavigationGuardUtils {

    /**
     * 会員情報が登録済みかチェックします。
     */
    public static checkUserInfo(next: GtmRouterNext) {
        UserInfoUtils.getUserInfo((status: number, userInfo: any) => {
            console.log(`CheckUserInfo HTTP Status = ${status}`);
            if (status == 200 && userInfo) {
                // アカウント登録済みの場合、処理継続
                next.next();
            } else if (status == 404) {
                // アカウント未登録の場合、会員登録画面へ
                next.next("/client/regist", false);
            } else {
                // 上記以外の場合エラー画面へ遷移
                next.next("/client/error");
            }
        })
    }

    /**
     * 認証済みかチェックします。
     * @param to ルート（遷移先）
     * @param from ルート（遷移元）
     * @param next1 処理継続ための関数
     * @param callback 認証済みの場合に実行する関数
     * @param redirectUriKeyName 戻り先URLのセッション名
     * @param displayModeKeyName 画面表示モードのセッション名
     * @param selectedPageKeyName マイページ画面における選択メニューのセッション名
     */
    public static checkAuth(to: Route,
                            from: Route,
                            next1: GtmRouterNext,
                            callback: (next2: GtmRouterNext) => void,
                            redirectUriKeyName: string,
                            displayModeKeyName: string,
                            selectedPageKeyName: string
    ) {
        // 戻り先URL
        let redirectUri = (to.query.redirectUrl) ? to.query.redirectUrl.toString() : null;
        let param = (redirectUri) ? `?redirect_uri=${encodeURIComponent(redirectUri)}` : "";
        // 画面表示モード
        let displayMode = (to.query.displayMode) ? to.query.displayMode.toString() : null;

        // セッション・ストレージに画面表示モードを登録する
        if (displayMode) sessionStorage.setItem(displayModeKeyName, displayMode);

        // ページ指定
        let selectedPage = (to.query.selectedPage) ? to.query.selectedPage.toString() : null
        if (selectedPage) sessionStorage.setItem(selectedPageKeyName, selectedPage)

        axios.get(`/auth${param}`)
            .then(cb => {
                // One-ID認証済みの場合
                // セッション・ストレージに戻り先URIを登録する
                if (redirectUri) sessionStorage.setItem(redirectUriKeyName, redirectUri);

                // セッション・ストレージにAuth0 ユーザIDのハッシュ値を登録する
                if (cb.data) sessionStorage.setItem('gtm_auth_id', cb.data);

                // 指定されたコールバック関数を実行
                callback(next1);

            })
            .catch(error => {
                // 未認証、通信エラーの場合

                // ログに出力
                AxiosUtils.log(error, from);

                // HTTPステータスコードが「401（未認証）」、且つ、戻り先URL（Auth0）が指定されている場合
                if (AxiosUtils.isUnauthorized(error)) {

                    // セッション・ストレージに戻り先URIを登録する
                    if (redirectUri) sessionStorage.setItem(redirectUriKeyName, redirectUri.toString());
                    if (to.fullPath) sessionStorage.setItem("path",to.fullPath)
                    // 指定されたURL（Auth0ログインURL）にアクセス
                    window.location.href = error.response.data.replace("redirect: ", "");
                    return;
                }

                // 上記以外の場合、エラー画面に遷移
                next1.next("/client/error");
            });
    }
}